require.config({
    baseUrl: 'App',
    paths: {
        'text': '../scripts/text',
        'durandal': '../scripts/durandal',
        'plugins': '../scripts/durandal/plugins',
        'transitions': '../scripts/durandal/transitions',
        'i18next': '../scripts/i18next-1.8.0',
        'knockout': '../scripts/knockout-3.4.2',
        'bootstrap': '//cdn.jsdelivr.net/npm/bootstrap@3.4.1/dist/js/bootstrap.min',
        'jquery': '//cdn.jsdelivr.net/npm/jquery@2.2.4/dist/jquery.min'
    },
    shim: {
        'bootstrap': {
            deps: ['jquery'],
            exports: 'jQuery'
        }
    }
});

define('jquery', [],function () { return jQuery; });
define('knockout', ko);
define('kendo', kendo);

require(["bootstrapper"], function (bootstrapper) {
    bootstrapper.run(kendo);

    $.material.init();
});

define("main", function(){});

